const DescriptionLabel = ({ text }) => {
    return (
        <p style={{color:'white', fontSize: '20px', textAlign:'center'}}>{text}</p>

    )
}

export default DescriptionLabel